import { render } from "./candidate-grid.vue?vue&type=template&id=c2e248ea"
import script from "./candidate-grid.vue?vue&type=script&lang=js"
export * from "./candidate-grid.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__